import { FC } from "react";
import { MotifTheme } from "@ey-xd/motif-react";

type ThemeProps = {
  variant: string;
};
const Theme: FC<ThemeProps> = ({ variant }) => {
  return <MotifTheme variant={variant} />;
};
export default Theme;
